import React, { Component } from 'react';

class Parameter extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            value: ''
        }
    }

    onValueChange(e) {

        this.setState({ value: e.target.value }, () => {
            this.props.onValueChange(this.state.value);
        });
    }

    renderInput(type, defaultValue, name, inputOptions, textInputType) {
        

        if (type == 'select') {
            const options = inputOptions.map(option => {
                return <option key={option} value={option}>{option}</option>;
            });
            return (
                <select name="somename" className="SelectBox select-dropdown" onChange={this.onValueChange.bind(this)}>
                    {options}
                </select>
            );
        }

        return (
            <input type={textInputType} name="api_key" value={this.state.value} onChange={this.onValueChange.bind(this)} />
        );
    }

    render() {
        const { name, defaultValue, inputType, inputOptions, type, location, description, onValueChange, textInputType } = this.props;

        return (
            <tr>
                <td scope="row">{name}</td>
                <td>
                    {this.renderInput(inputType, defaultValue, name, inputOptions, textInputType)}
                    {/* <input type="text" name="api_key" value="AKY012313" /> */}
                </td>
                <td>{type}</td>
                <td>{location}</td>
                <td>{description}</td>
            </tr>
        );
    }
}

export default Parameter;



// WEBPACK FOOTER //
// ./src/views/components/Parameter.jsx